export const useIcons = () => {
    // Temporary helper function to migrate to new  spark syntax
    type Icon = {
        set?: string
        name?: string
        type?: string
    }
    const iconName = (icon?: Icon) => {
        if (isNil(icon) || !icon?.name) {
            return
        }
        // if icon type is blank, omit from name
        if (!icon?.type) {
            return `${icon?.set}:${icon?.name}`
        }

        return `${icon?.set}:${icon?.name}-${icon?.type}`
    }

    return {
        iconName,
    }
}
